/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState, useCallback } from 'react';
import { twMerge } from '@/lib/twMerge';
import clsx from 'clsx';
import Link from 'next/link';
import { DefaultLinkProps } from '@/types/props/components/common';
export default function DefaultLink({
  className: classNameProp = '',
  cooldown = 1000,
  onClick,
  children,
  rawLink = false,
  ...props
}: DefaultLinkProps) {
  const [isSpamProtected, setIsSpamProtected] = useState(false);

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault();

      setIsSpamProtected(true);
      onClick?.(event);

      setTimeout(() => {
        setIsSpamProtected(false);
      }, cooldown);
    },
    [cooldown, onClick]
  );

  const handleClickHandler = onClick ? handleClick : undefined;

  if (rawLink) {
    return (
      <a
        {...props}
        onClick={handleClickHandler}
        className={twMerge(
          clsx(
            'tw-inline-block tw-text-center tw-align-middle tw-leading-normal tw-text-black tw-no-underline',
            isSpamProtected && 'tw-pointer-events-none tw-opacity-70'
          ),
          classNameProp
        )}
      >
        {children}
      </a>
    );
  }

  return (
    <Link
      {...props}
      onClick={handleClickHandler}
      className={twMerge(
        clsx(
          'tw-inline-block tw-text-center tw-align-middle tw-leading-normal tw-text-black tw-no-underline',
          isSpamProtected && 'tw-pointer-events-none tw-opacity-70'
        ),
        classNameProp
      )}
    >
      {children}
    </Link>
  );
}
